// Поиск по спискам: любой кусок, в любом порядке.
//
// Раньше искали одним куском подряд: строка сравнивалась целиком, и «дуб 012»
// не находило «Дуб Вотан … #LT-20260819-012», потому что между «дуб» и «012»
// стоит полтора десятка символов. Человек же держит в голове два-три обрывка —
// цвет и хвост номера заказа — и набирает именно их. Когда работа накопилась и
// строк под три десятка, такой поиск не помогает вовсе: приходится листать.
//
// Поэтому запрос режем на слова и требуем, чтобы КАЖДОЕ нашлось где-нибудь
// среди полей строки. Порядок не важен, поле не важно.

// «ё» и «е» в цехе пишут как придётся: «плёнка» и «пленка» — одно и то же
// слово, а для поиска это два разных. То же с «й»/«и» — на планшете их путают.
const fold = (v) => String(v ?? '')
  .toLowerCase()
  .replace(/ё/g, 'е')
  .replace(/й/g, 'и');

/**
 * makeMatcher('дуб 012') -> (…поля) => true//false
 * Пустой запрос пропускает всё.
 */
export function makeMatcher(query) {
  const words = fold(query).split(/\s+/).filter(Boolean);
  if (!words.length) return () => true;
  return (...fields) => {
    const hay = fold(fields.filter(x => x !== null && x !== undefined).join(' '));
    return words.every(w => hay.includes(w));
  };
}

/** Разовая проверка, когда матчер держать негде. */
export const matches = (query, ...fields) => makeMatcher(query)(...fields);
